export default __webpack_public_path__ + "static/media/NIAS0090.34I-32791_-17902_0.82f2f805.jpg";